import App from './app';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpgradeModule } from '@angular/upgrade/static';

import Ng2AppModule from './angular2rootModule';

angular.element(document).ready(() => {
  platformBrowserDynamic().bootstrapModule(Ng2AppModule).then(platformRef => {
    const upgrade = platformRef.injector.get(UpgradeModule);
    upgrade.bootstrap(document.body, [App.name])
  });
});



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/